module.exports = __webpack_public_path__ + "static/media/vicricus-profile.3061d065.webp";